import { motion } from "framer-motion";

const steps = [
  { num: "01", title: "Discovery & Strategy", desc: "A 30-minute call about your trade, your service area, and the jobs you actually want more of." },
  { num: "02", title: "Architectural Design", desc: "A bespoke design concept — typography, photography direction, and layout engineered around your customers." },
  { num: "03", title: "Lightning Build & SEO", desc: "Sub-second pages, local search structure, and quote funnels wired to your phone and inbox." },
  { num: "04", title: "Launch & Lead Automation", desc: "We launch, monitor, and tune. You answer better calls from better customers." },
];

export default function Process() {
  return (
    <section id="process" data-testid="agency-process-section" className="py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold/80 mb-4">The Craft Process</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-[#F8F6F0] tracking-tight max-w-2xl">
            From first call to first lead in <span className="gold-text italic">fourteen days.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => (
            <motion.div
              key={s.num}
              data-testid={`process-step-${s.num}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group relative rounded-2xl border gold-border-subtle bg-surface/60 p-8 hover:border-gold/40 transition-colors duration-500"
            >
              <span className="font-serif italic text-6xl text-gold/15 group-hover:text-gold/30 transition-colors duration-500">{s.num}</span>
              <h3 className="font-serif text-xl text-[#F8F6F0] mt-5 mb-3">{s.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
